import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { HashRouter } from "react-router-dom";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import store from "./Redux/Store/Store";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "leaflet/dist/leaflet.css";
import { installGlobalAxios } from "./Utility/secureChannel";

// Seedhe axios.get/post(`${baseUrl}...`) wali calls bhi secure channel se jaayein
installGlobalAxios();

const queryClient = new QueryClient();

export { baseUrl, ImagebaseUrl } from "./Baseurl";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <HashRouter>
        <Provider store={store}>
          <App />
        </Provider>
      </HashRouter>
    </QueryClientProvider>
  </React.StrictMode>,
);

reportWebVitals();
